import Vue from 'vue';
import Component from 'vue-class-component';
import moment from 'moment';
import App from './App.vue';
import router from './router';
import store from './store/index';
import i18n from './i18n';
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;
Vue.prototype.$goToPage = (name: string) => {
  router.push({ name });
};

Vue.filter('date', (value: string) => {
  if (!value) {
    return '';
  }
  return moment(value).format('YYYY-MM-DD');
});

Vue.filter('dateTime', (value: string) => {
  if (!value) {
    return '';
  }
  return moment(value).format('YYYY-MM-DD HH:mm');
});

const roleNames = ['', '個人', '公司', '系統'];
Vue.filter('role', (value: number | number[]) => {
  const arr = Array.isArray(value) ? value : [value];

  return arr.map((roleId) => roleNames[roleId]).join();
});

const platformNames = ['', 'Web', 'Android', '', 'iOS'];
Vue.filter('platform', (value: number) => platformNames[value]);

const auditFlowNames = ['未送審', '已送審', '通過', '未通過'];
Vue.filter('auditFlow', (value: number) => auditFlowNames[value]);

// 註冊 route hooks
Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate',
]);

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
  components: { App },
}).$mount('#app');
